import * as Sentry from "@sentry/react";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { configureTileCdnBaseUrl } from "@west-marches/shared";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fontsource/fondamento/latin-400.css";
import "@/index.css";
import { getBrowserQueryClient } from "@/lib/queryClient";
import { routeTree } from "@/routeTree.gen";

if (import.meta.env.VITE_SUPABASE_TILE_CDN_BASE_URL) {
  configureTileCdnBaseUrl(import.meta.env.VITE_SUPABASE_TILE_CDN_BASE_URL);
}

const queryClient = getBrowserQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  _experiments: { enableLogs: true },
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
